import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {ref, onActivated, reactive} from 'vue';
import { useRoute, useRouter } from 'vue-router'
import LaborIndex from '@/views/ViewsComponents/labor/laborIndex.vue'
import ContractList from '@/views/ViewsComponents/labor/contractList.vue'
import DifferentList from '@/views/ViewsComponents/labor/differentList.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeName = ref('first')

// let userName = ref('')
const ContractListEle = ref()
const switchTabsHandle = (_user: string) => {
  ContractListEle.value.searchForm.dataObj.key = _user
  ContractListEle.value.searchForm.submitHandle()
  activeName.value = 'second'
}

const route = useRoute()
const router = useRouter()

let convenientParams = reactive({})
onActivated(() => {
  let {type, id} = route.query
  if(type){
    // convenientParams.value = {...route.query}
    Object.assign(convenientParams, {...route.query})
    activeName.value = 'second'
  }
  
  /* if(route.params.page){
    convenientParams.value = {...route.query}
    activeName.value = 'second'
    router.push({path: '/labor-contract'})
  } else {
  } */
})


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "劳动合同首页",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(LaborIndex, { onToContract: switchTabsHandle })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "劳动合同档案",
          name: "second",
          lazy: ""
        }, {
          default: _withCtx(() => [
            (activeName.value === 'second')
              ? (_openBlock(), _createBlock(ContractList, {
                  key: 0,
                  ref_key: "ContractListEle",
                  ref: ContractListEle,
                  convenientParams: _unref(convenientParams)
                }, null, 8, ["convenientParams"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "差异值查询",
          name: "third",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(DifferentList)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})